export default __webpack_public_path__ + "static/media/icon-004.c02ea88c.svg";